<template>
    <div class="control-group">
        <div class="control-label"><Label :description="description" :label="label"></Label></div>
        <div class="controls">

              <div class="form-check" v-for="item in options">
                <input type="radio" class="pull-left form-check-input" :id="item.name + item.value"
                       v-model="currentOption" :value="item.value" :key="item.Id" :selected="value === item.value" @input="$emit('update:value', $event.target.value)" />
                <label class="radio form-check-label" :for="item.name + item.value">
                    {{item.text}}
                </label>
              </div>

        </div>
    </div>
</template>

<script>
    import Label from "./Label";

    export default {
        components: {
            Label
        },
        props: {
            name: null,
            label: null,
            description: null,
            value: null,
            options: null,
            defaultValue: null,
        },
        data() {
            return {
                currentOption: ""
            };
        },
        watch: {
            value: function(newValue){
                this.currentOption = newValue;
            }
        },
        mounted() {
            if (this.defaultValue) {
                this.currentOption = this.defaultValue;
            } else {
                this.currentOption = this.options[0].value;
            }
            this.$emit('update:value', this.currentOption);
        },
        methods: {

        }
    };
</script>
